<template>
  <v-navigation-drawer
    v-model="drawer"
    :right="$vuetify.rtl"
    app
    width="200"
    class="appDrawer elevation-1"
    temporary
  >
    <v-divider></v-divider>

    <v-list nav dense>
      <v-list-item-group
        v-model="group"
        active-class="primary--text text--accent-4"
      >
        <v-list-item v-for="item in items" :key="item.title" link :to="item.to">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="body-2">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
/* eslint-disable no-unused-vars */
import event from "../eventBus.js";

export default {
  name: "Drawer",
  data() {
    return {
      group: "",
      items: [],
      drawer: false,
    };
  },
  created() {
    event.$on("toggleDrawer", (arg) => {
      this.drawer = !this.drawer;
    });
  },
};
</script>

<style scoped>
.v-navigation-drawer {
  font-size: 1rem;
}
</style>
